import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { BiEditAlt } from 'react-icons/bi';

const NotesCellRenderer = (props) => {
  const [expanded, setExpanded] = useState(false);
  const note = props.data?.notes || '';
  const isLong = note.length > 10;
  const displayedText = expanded || !isLong ? note : note.slice(0, 100) + '...';

  const handleEdit = () => {
    props.context.setShowEditJobPatient(false);
    setTimeout(() => {
      props.context.setPatientId(props.data.patientId);
      props.context.setEditJobData(props.data);
      props.context.setShowEditJobPatient(true);
    }, 100);
  };

  return (
    <div
      className='d-flex align-items-center actions_ag_grid'
      style={{
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <div
        style={{
          flex: 1,
          marginRight: '10px',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          cursor: isLong ? 'pointer' : 'default',
      //   color: isLong ? '#007bff' : 'inherit',
        }}
        onClick={() => isLong && setExpanded(!expanded)}
      >
        {displayedText}
      </div>

      <Tooltip placement='left' title='Edit'>
        <BiEditAlt
          onClick={handleEdit}
          className='mx-2 edit_btn'
          style={{ fontSize: '1.4rem', cursor: 'pointer' }}
        />
      </Tooltip>
    </div>
  );
};

export default NotesCellRenderer;
